import { notificationConstants } from '../constants'

export const ReSendNip = (state = {}, action) => {
  switch (action.type) {
    case notificationConstants.NIP_REQUEST:
      return { loading: true, items: undefined, error: undefined }//Mostrar gif loader mientras ejecuta request
    case notificationConstants.NIP_SUCCESS:
      return {
        loading: false,
        items: action.responseNipData.Body,//Obtener respuesta correcta del API
      }
    case notificationConstants.NIP_FAILURE:
      return {
        loading: false,
        items: undefined,
        error: action.error//Mostrar error del API
      }
    default:
      return state//Retornar state vacío o actual
  }
}
//Siguiente paso => Volver a screens con respuesta

export const SendNip = (state = {}, action) => {
  switch (action.type) {
    case notificationConstants.SENDNIP_REQUEST:
      return { loading: true, items: undefined, error: undefined }//Mostrar gif loader mientras ejecuta request
    case notificationConstants.SENDNIP_SUCCESS:
      return {
        loading: false,
        items: action.sendNipData.Body,//Obtener respuesta correcta del API
      }
    case notificationConstants.SENDNIP_FAILURE:
      return {
        loading: false,
        items: undefined,
        error: action.error//Mostrar error del API
      }
    default:
      return state//Retornar state vacío o actual
  }
}

export const UpdateMetadata = (state = {}, action) => {
  switch (action.type) {
    case notificationConstants.NIP_UPDATE_REQUEST:
      return { loading: true, items: undefined, error: undefined }//Mostrar gif loader mientras ejecuta request
    case notificationConstants.NIP_UPDATE_SUCCESS:
      return {
        loading: false,
        items: action.responseNipData.Body,//Obtener respuesta correcta del API
      }
    case notificationConstants.NIP_UPDATE_FAILURE:
      return {
        loading: false,
        items: undefined,
        error: action.error//Mostrar error del API
      }
    default:
      return state//Retornar state vacío o actual
  }
}
//Siguiente paso => Volver a screens con respuesta
export const NotificationChangePass = (state = {}, action) => {
  switch (action.type) {
    case notificationConstants.NOTIFICATION_CHANGEPASS_REQUEST:
      return { loading: true, items: undefined, error: undefined }
      
    case notificationConstants.NOTIFICATION_CHANGEPASS_SUCCESS:
      return {
        loading: false,
        items: action.notificationCPassData.Body,
        error: undefined
      }
      
    case notificationConstants.NOTIFICATION_CHANGEPASS_FAILURE:
      return { loading: false, items: undefined, error: action.error }
      
    default:
      return state
  }
}

export const QrImage = (state = {}, action) => {
  switch (action.type) {
    case notificationConstants.QR_IMAGE_REQUEST:
      return { loading: true, items: undefined, error: undefined }
      
    case notificationConstants.QR_IMAGE_SUCCESS:
      return {
        loading: false,
        items: action.qrimage.data,
        itemsURL: action.qrimage.url,
        type: action.qrimage.type,
        extension: action.qrimage.extension,
        error: undefined
      }
      
    case notificationConstants.QR_IMAGE_FAILURE:
      return { loading: false, items: undefined, error: action.error }
      
    default:
      return state
  }
}
